import React, { Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import cn from 'classnames';

import {
  nextAction,
} from 'actions/workflow';
import { parseUrlParams } from 'utils/parseUrlParams';

import Header from 'components/Header';
import Footer from 'components/Footer';
import get from 'lodash/get';

import style from './style.scss';

const CreditAppDoc = ({ history }) => {
  const dispatch = useDispatch();
  const workflow = useSelector(state => state.workflow);

  const onMessageReceived = (event) => {
    const { data } = event;
    if (data.docuSignComplete) {
      const params = parseUrlParams(window.location.search);
      if (params.applicationId) {
        dispatch(nextAction({
          data: {},
          url: `/workflows/application/${params.applicationId}/workflow/dtm/next`,
          success: () => {
            history.push('/dashboard/borrowers-merchant/signloandocument');
          },
          fail: () => {},
        }));
      }
    }
  };

  useEffect(() => {
    window.addEventListener('message', onMessageReceived, false);
    const params = parseUrlParams(window.location.search);
    if (get(workflow, ['state', 'data']) === undefined) {
      history.push(`/dashboard/borrowers-merchant/?applicationId=${params.applicationId || ''}`);
    }
    if (!params.applicationId) {
      history.push('/dashboard/borrowers-merchant');
    }

    return () => {
      window.removeEventListener('message', onMessageReceived, false);
    };
  }, []);

  return (
    <Fragment>
      <Header />
      <section className="container section">
        <div className="grid-container fluid page-sign-loan">
          <div className="grid-x">
            <div className="cell small-12 large-9 main-column">
              <iframe
                src={get(workflow, ['state', 'data', 'url'])}
                // src="http://localhost:3000/dashboard/borrowers-merchant/complete"
                width="100%"
                height="1200"
                title="docusign"
                id="docusign"
                frameBorder="0"
              />
            </div>

            <div className={cn('cell small-12 large-3', style.loanInfo)}>
              <h4>Sign Credit Loan Document</h4>
              <p>Borrower must review and e-sign the Credit Loan Document to the left to finalize their loan.</p>

              <h5>Your Approved Loan</h5>
              <div className="grid-x grid-margin-x">
                <div className="cell small-7">
                  <p className="p-small">Estimated Monthly Payment</p>
                </div>
                <div className="cell small-5 text-right">
                  <h6 className={style.monthlyPayments}>$80.86</h6>
                </div>
              </div>
              <div className="grid-x grid-margin-x">
                <div className="cell small-7">
                  <p className="p-small">Amount Financed</p>
                </div>
                <div className="cell small-5 text-right">
                  <h6>$2,000.00</h6>
                </div>
              </div>
              <div className="grid-x grid-margin-x">
                <div className="cell small-7">
                  <p className="p-small">Loan Term</p>
                </div>
                <div className="cell small-5 text-right">
                  <h6>60 Months</h6>
                </div>
              </div>
              <div className="grid-x grid-margin-x">
                <div className="cell small-7">
                  <p className="p-small">Interest Rate</p>
                </div>
                <div className="cell small-5 text-right">
                  <h6>27.45%</h6>
                </div>
              </div>
              <div className="grid-x grid-margin-x">
                <div className="cell small-12 padded-bottom">
                  <p className="p-small"><em>Special Promotion:</em>  No Interest on principal if your loan is paid in full within the first six months</p>
                </div>
                <div className="cell small-12">
                  <div className="expanded button-group">
                    <a href="#esignLater" className={cn('button secondary', style.eSignLater)}>eSign Later</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </Fragment>
  );
};

CreditAppDoc.propTypes = {
  history: PropTypes.object.isRequired,
};

CreditAppDoc.defaultProps = {
};

export default CreditAppDoc;



// WEBPACK FOOTER //
// ./src/containers/pages/BorrowerMerchantApply/InternalPages/CreditAppDoc/index.js